module.exports = __webpack_public_path__ + "static/media/icon-character__vladimir-putin-hover.afa9c6bf.svg";